export const MENTOR_LIST_REQUEST = "MENTOR_LIST_REQUEST";
export const MENTOR_LIST_SUCCESS = "MENTOR_LIST_SUCCESS";
export const MENTOR_LIST_FAIL = "MENTOR_LIST_FAIL";

export const MENTOR_DETAILS_REQUEST = "MENTOR_DETAILS_REQUEST";
export const MENTOR_DETAILS_SUCCESS = "MENTOR_DETAILS_SUCCESS";
export const MENTOR_DETAILS_FAIL = "MENTOR_DETAILS_FAIL";

export const STUDENTS_OF_MENTOR_REQUEST = "STUDENTS_OF_MENTOR_REQUEST";
export const STUDENTS_OF_MENTOR_SUCCESS = "STUDENTS_OF_MENTOR_SUCCESS";
export const STUDENTS_OF_MENTOR_FAIL = "STUDENTS_OF_MENTOR_FAIL";

export const MENTOR_ADD_TIMESLOTS_REQUEST = "MENTOR_ADD_TIMESLOTS_REQUEST";
export const MENTOR_ADD_TIMESLOTS_SUCCESS = "MENTOR_ADD_TIMESLOTS_SUCCESS";
export const MENTOR_ADD_TIMESLOTS_FAIL = "MENTOR_ADD_TIMESLOTS_FAIL";

export const MENTOR_ADD_APPOINTMENT_REQUEST = "MENTOR_ADD_APPOINTMENT_REQUEST";
export const MENTOR_ADD_APPOINTMENT_SUCCESS = "MENTOR_ADD_APPOINTMENT_SUCCESS";
export const MENTOR_ADD_APPOINTMENT_FAIL = "MENTOR_ADD_APPOINTMENT_FAIL";

export const UPDATE_AVAILABILITY_DATA_STEP_1 =
  "UPDATE_AVAILABILITY_DATA_STEP_1";
export const UPDATE_AVAILABILITY_DATA_STEP_2 =
  "UPDATE_AVAILABILITY_DATA_STEP_2";

export const SCHEDULE_ADD_REQUEST = "SCHEDULE_ADD_REQUEST";
export const SCHEDULE_ADD_SUCCESS = "SCHEDULE_ADD_SUCCESS";
export const SCHEDULE_ADD_FAIL = "SCHEDULE_ADD_FAIL";

export const GET_MENTOR_SCHEDULES_REQUEST = "GET_MENTOR_SCHEDULES_REQUEST";
export const GET_MENTOR_SCHEDULES_SUCCESS = "GET_MENTOR_SCHEDULES_SUCCESS";
export const GET_MENTOR_SCHEDULES_FAIL = "GET_MENTOR_SCHEDULES_FAIL";

export const CREATE_EVENT_REQUEST = "CREATE_EVENT_REQUEST";
export const CREATE_EVENT_SUCCESS = "CREATE_EVENT_SUCCESS";
export const CREATE_EVENT_FAIL = "CREATE_EVENT_FAIL";
